import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function HomeContact() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          sectionRef.current?.querySelectorAll('.hct-fade').forEach((el, i) => {
            setTimeout(() => {
              (el as HTMLElement).classList.add('opacity-100', 'translate-y-0');
              (el as HTMLElement).classList.remove('opacity-0', 'translate-y-8');
            }, i * 150);
          });
        }
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="py-28 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #020B18 0%, #061428 50%, #0A1E3D 100%)' }}
      ref={sectionRef}
    >
      {/* Grid texture */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: 'linear-gradient(#1E6FFF 1px, transparent 1px), linear-gradient(90deg, #1E6FFF 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      {/* Glow orbs */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(30,111,255,0.12) 0%, transparent 70%)',
          filter: 'blur(60px)',
        }}
      />

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
        <p className="hct-fade opacity-0 translate-y-8 transition-all duration-700 text-[#4DA3FF] text-xs tracking-[0.4em] mb-6 uppercase">
          / Free Consultation
        </p>
        <h2 className="hct-fade opacity-0 translate-y-8 transition-all duration-700 text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight mb-6">
          まずは、<br />お気軽にご相談を。
        </h2>
        <div
          className="hct-fade opacity-0 translate-y-8 transition-all duration-700 w-16 h-px mx-auto mb-8"
          style={{ background: 'linear-gradient(90deg, transparent, #1E6FFF, transparent)' }}
        />
        <p className="hct-fade opacity-0 translate-y-8 transition-all duration-700 text-white/60 text-base md:text-lg leading-relaxed mb-12 max-w-xl mx-auto">
          初回ご相談は無料です。WEBサイト制作・SNS運用・デジタルマーケティングについて、
          どんなご相談でもお気軽にどうぞ。
        </p>
        <div className="hct-fade opacity-0 translate-y-8 transition-all duration-700 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="text-white px-10 py-5 rounded-full text-sm tracking-widest font-bold transition-all duration-300 whitespace-nowrap hover:opacity-90 hover:scale-105"
            style={{ background: 'linear-gradient(90deg, #1E6FFF 0%, #0099FF 100%)' }}
          >
            無料相談を申し込む
          </Link>
          <Link
            to="/about"
            className="border border-white/30 text-white px-10 py-5 rounded-full text-sm tracking-widest hover:bg-white/10 hover:border-white/50 transition-colors whitespace-nowrap"
          >
            プロフィールを見る
          </Link>
        </div>
      </div>
    </section>
  );
}
